export default __webpack_public_path__ + "static/environment-recommended-2024-f5ff3f631724b02a234277fea8b2d91f.png";